import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
        self.prevNextButtons = self.elem.getAttribute('data-prev-next-buttons');
        self.autoplay = self.elem.getAttribute('data-autoplay');
        self.startIndex = self.elem.getAttribute('data-start-index') || 1;
        self.showThumbnails = self.elem.getAttribute('data-show-thumbnails') === 'true';
    }

    init() {
        let self = this;

        // Flickity options
        let flktyOptions = {
            contain: false,
            draggable: true,
            wrapAround: true,
            pageDots: !self.showThumbnails,
            prevNextButtons: self.prevNextButtons ?? false,
            autoPlay: self.autoplay ? parseInt(self.autoplay) : false,
            cellAlign: 'center',
            initialIndex: parseInt(self.startIndex)
        };

        // Initialise Flickity
        const flkty = new Flickity(self.carousel, flktyOptions);

        // Re-layout after all images have loaded to fix cells that appear blank on first load
        window.addEventListener('load', () => flkty.resize());

        // Thumbnail navigation
        if (self.showThumbnails) {
            self.elem.classList.add('gallery--has-thumbnails');

            const thumbnails = self.elem.querySelectorAll('[data-thumbnail-index]');

            thumbnails.forEach((thumb) => {
                thumb.addEventListener('click', () => {
                    const index = parseInt(thumb.getAttribute('data-thumbnail-index'));
                    flkty.select(index);
                });
            });

            const thumbnailContainer = self.elem.querySelector('.gallery__thumbnails');

            flkty.on('select', () => {
                thumbnails.forEach((thumb) => {
                    const index = parseInt(thumb.getAttribute('data-thumbnail-index'));
                    const isActive = index === flkty.selectedIndex;
                    thumb.classList.toggle('is-active', isActive);

                    if (isActive && thumbnailContainer) {
                        const containerRect = thumbnailContainer.getBoundingClientRect();
                        const thumbRect = thumb.getBoundingClientRect();
                        const overflowLeft = thumbRect.left - containerRect.left;
                        const overflowRight = thumbRect.right - containerRect.right;

                        if (overflowLeft < 0) {
                            thumbnailContainer.scrollBy({ left: overflowLeft, behavior: 'smooth' });
                        } else if (overflowRight > 0) {
                            thumbnailContainer.scrollBy({ left: overflowRight, behavior: 'smooth' });
                        }
                    }
                });
            });
        }
    }
}

export default Carousel;